import i18n from 'i18next';
import {
  GREYHOUNDS_RACING,
  HORSE_RACING
} from 'utils/constants/sportsbook/racing-sport';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { CountSetter, NavSectionItem } from 'interfaces/generic';
import {
  getESportsGamesCount,
  getRacingGamesCount,
  getSportsbookGamesCount
} from 'services/sportsbook';

export const EasyAccessSections: NavSectionItem[] = [
  {
    id: 1,
    get title() {
      return i18n.t('pages.home');
    },
    pageType: 'home',
    iconInfo: {
      lib: 'generic',
      name: 'tenniscourt',
      theme: 'colored'
    }
  },
  {
    id: 2,
    get title() {
      return i18n.t('pages.liveMatches');
    },
    pageType: 'live',
    iconInfo: {
      lib: 'generic',
      name: 'livestreaming',
      theme: 'colored'
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getSportsbookGamesCount(true, countSetter);
    }
  },
  {
    id: 3,
    get title() {
      return i18n.t('pages.preMatch');
    },
    pageType: 'prematch',
    iconInfo: {
      lib: 'generic',
      name: 'upcoming',
      theme: 'colored'
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getSportsbookGamesCount(false, countSetter);
    }
  },
  {
    id: 4,
    get title() {
      return i18n.t('pages.favorites');
    },
    iconInfo: {
      lib: 'generic',
      name: 'medal',
      theme: 'colored'
    }
  }
];

export const ESportEasyAccessSections: NavSectionItem[] = [
  {
    id: 1,
    get title() {
      return i18n.t('pages.allGames');
    },
    pageType: 'all',
    iconInfo: {
      lib: 'generic',
      name: 'allesports',
      theme: `${SpringConfigs.SPORT_ICON_STYLE}`
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getESportsGamesCount(true, countSetter, 'AllESports', true);
    },
    queryStringObject: {
      type: 'all'
    }
  },
  {
    id: 2,
    get title() {
      return i18n.t('pages.liveMatches');
    },
    pageType: 'live',
    iconInfo: {
      lib: 'generic',
      name: 'livestreaming',
      theme: `${SpringConfigs.SPORT_ICON_STYLE}`
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getESportsGamesCount(true, countSetter, 'AllESports');
    },
    queryStringObject: { type: 'live' }
  },
  {
    id: 3,
    get title() {
      return i18n.t('pages.preMatch');
    },
    pageType: 'prematch',
    iconInfo: {
      lib: 'generic',
      name: 'upcoming',
      theme: `${SpringConfigs.SPORT_ICON_STYLE}`
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getESportsGamesCount(false, countSetter, 'AllESports');
    },
    queryStringObject: { type: 'prematch' }
  }
];

export const RacingEasyAccessSections: NavSectionItem[] = [
  {
    id: 31,
    get title() {
      return i18n.t('pages.horseRacing');
    },
    pageType: 'racing',
    iconInfo: {
      lib: 'sports',
      name: HORSE_RACING.alias
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getRacingGamesCount([HORSE_RACING.id], countSetter);
    },
    queryStringObject: { type: HORSE_RACING.alias }
  },
  {
    id: 184,
    get title() {
      return i18n.t('pages.greyhounds');
    },
    pageType: 'racing',
    iconInfo: {
      lib: 'sports',
      name: GREYHOUNDS_RACING.alias
    },
    countGetter: (countSetter: CountSetter): string | null => {
      return getRacingGamesCount([GREYHOUNDS_RACING.id], countSetter);
    },
    queryStringObject: { type: GREYHOUNDS_RACING.alias }
  }
];
